import i18n from '../../i18n';

export default {
  checkPoints: 'اهداف',
  addCheckPoint: 'افزودن هدف اختصاصی',
  thereIsNoCheckPointsYet: 'هنوز هدفی وجود ندارد',
  specificGoals: 'اهداف اختصاصی این گزارش',
  surveyGoals: 'اهداف مشترک در این پرسشنامه',
  addSurveyCheckPoint: 'افزودن هدف مشترک ',
  checkPointRemoved: 'هدف مورد نظر حذف شد',

  checkPointSavedSuccessfully: (isUpdate: boolean) => {
    if (isUpdate) {
      return i18n.t('targetUpdated', { ns: 'survey' });
    }
    return i18n.t('targetCreated', { ns: 'survey' });
  },
};
